import { render, staticRenderFns } from "./ProductFeeItem.vue?vue&type=template&id=12bf8c70&scoped=true&"
import script from "./ProductFeeItem.vue?vue&type=script&lang=js&"
export * from "./ProductFeeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf8c70",
  null
  
)

export default component.exports